export const GLOBAL_STATE = 'Country'

export const COUNTRY = 'COUNTRY' as const
export const COUNTRY_CREATE = 'COUNTRY_CREATE' as const
export const COUNTRY_DELETE = 'COUNTRY_DELETE' as const
export const COUNTRY_LIST = 'COUNTRY_LIST' as const
export const COUNTRY_ALL = 'COUNTRY_ALL' as const
